/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateMultisigRequest,
  CreateMultisigResponse,
  MultisigMemberDto,
  MultisigMembersResponse,
  SimpleAidDto,
} from '../models/index';
import {
    CreateMultisigRequestFromJSON,
    CreateMultisigRequestToJSON,
    CreateMultisigResponseFromJSON,
    CreateMultisigResponseToJSON,
    MultisigMemberDtoFromJSON,
    MultisigMemberDtoToJSON,
    MultisigMembersResponseFromJSON,
    MultisigMembersResponseToJSON,
    SimpleAidDtoFromJSON,
    SimpleAidDtoToJSON,
} from '../models/index';

export interface AddMemberRequest {
    multisigMemberDto: MultisigMemberDto;
}

export interface CreateMultisigOperationRequest {
    createMultisigRequest: CreateMultisigRequest;
}

export interface GetByMultisigAidRequest {
    aid: string;
}

/**
 * 
 */
export class MultisigControllerApi extends runtime.BaseAPI {

    /**
     * Add a member to multisig. This AID should be added before it
     */
    async addMemberRaw(requestParameters: AddMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimpleAidDto>> {
        if (requestParameters['multisigMemberDto'] == null) {
            throw new runtime.RequiredError(
                'multisigMemberDto',
                'Required parameter "multisigMemberDto" was null or undefined when calling addMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/multisig/member`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MultisigMemberDtoToJSON(requestParameters['multisigMemberDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimpleAidDtoFromJSON(jsonValue));
    }

    /**
     * Add a member to multisig. This AID should be added before it
     */
    async addMember(requestParameters: AddMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimpleAidDto> {
        const response = await this.addMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Save multisig aid and its members
     */
    async createMultisigRaw(requestParameters: CreateMultisigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateMultisigResponse>> {
        if (requestParameters['createMultisigRequest'] == null) {
            throw new runtime.RequiredError(
                'createMultisigRequest',
                'Required parameter "createMultisigRequest" was null or undefined when calling createMultisig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/agent/multisig`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMultisigRequestToJSON(requestParameters['createMultisigRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateMultisigResponseFromJSON(jsonValue));
    }

    /**
     * Save multisig aid and its members
     */
    async createMultisig(requestParameters: CreateMultisigOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateMultisigResponse> {
        const response = await this.createMultisigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get multisig members
     */
    async getByMultisigAidRaw(requestParameters: GetByMultisigAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MultisigMembersResponse>> {
        if (requestParameters['aid'] == null) {
            throw new runtime.RequiredError(
                'aid',
                'Required parameter "aid" was null or undefined when calling getByMultisigAid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/agent/multisig/{aid}/members`.replace(`{${"aid"}}`, encodeURIComponent(String(requestParameters['aid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MultisigMembersResponseFromJSON(jsonValue));
    }

    /**
     * Get multisig members
     */
    async getByMultisigAid(requestParameters: GetByMultisigAidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MultisigMembersResponse | null | undefined > {
        const response = await this.getByMultisigAidRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

}
